export const isFileValid = (file: File): boolean => {
  return (
    file.size < 1294967296 &&
    !/.asp|.css|.swf|.xhtml|.rhtml|.shtml|.js|.php/.test(file.name)
  );
};
